import React from "react";
import "../App.css";

const CookiePolicy = () => {
  return (
    <div
      className="hhg-hero-container"
      style={{
        flexDirection: "column",
        alignItems: "center",
        padding: "80px 20px",
        marginTop: "60px",
        background: "#ffffff",
      }}
    >
      <h1
        className="hhg-hero-heading"
        style={{
          textAlign: "center",
          marginBottom: "40px",
          fontSize: "42px",
          fontWeight: "700",
          color: "#0a4d68",
          letterSpacing: "1px",
        }}
      >
       
      </h1>

      <div
        className="terms-content"
        style={{
          maxWidth: "4000px",
          background: "#fafafa",
          padding: "40px 50px",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          fontSize: "17px",
          color: "#333",
          lineHeight: "1.8",
          fontFamily: "Kanit, sans-serif",
        }}
      >
        <h3
          style={{
            textAlign: "center",
            color: "#0a4d68",
            marginBottom: "25px",
            fontSize: "24px",
          }}
        >
          COOKIE POLICY
        </h3>

        {/* <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>COOKIE POLICY</h4> */}

<p>
  HHG INDUSTRIES PRIVATE LIMITED uses Cookies and other similar technologies (collectively, 
  “Cookies”) to personalize your experience on the website and the advertisements that 
  may be displayed.
</p>

<p>
  <strong>What is a Cookie?</strong> A cookie is a small text file placed on your device 
  (e.g., computer or smartphone) via your web browser at the request of the websites you 
  visit or applications you use. It stores information on your device for a limited 
  period of time. Cookies allow HHG INDUSTRIES PRIVATE LIMITED to recognize you and your device 
  each time you visit our Platforms.
</p>

<p><strong>Essential Cookies:</strong> Some Cookies are optional, but certain Cookies used 
by us are Essential for the proper functioning of the Website and to provide the best 
services to you. You cannot opt out of these Cookies because without them, 
HHG INDUSTRIES PRIVATE LIMITED wouldn't function properly. We use Essential Cookies for the 
following purposes:</p>

<ul style={{ listStyle: "disc", marginLeft: "30px" }}>
  <li>
    Recognise whether you are a first-time visitor or a return visitor to our Website and 
    tailor the presentation of our services, such as recalling your language and currency 
    preferences or your most recent searches.
  </li>
  <li>
    Remember information essential to displaying your search results, including your 
    language and currency preferences or certain product features made available to you.
  </li>
  <li>
    Remember your search criteria, such as routes and dates, as you navigate between pages 
    or move to specific sections within our Platforms.
  </li>
  <li>
    Gather important information on how our products and services are used, which helps 
    influence product decisions, updates, and improvements.
  </li>
  <li>
    Ensure our services are secure from automated agents, bots, and fraudulent activity.
  </li>
  <li>
    Provide login functionality and customer support services.
  </li>
</ul>

<h4 style={{ color: "#0a4d68", marginTop: "30px" }}>Opt-Out</h4>
<p>
  When you access our services for the first time on your device, we ask you to agree to 
  our use of Cookies and similar technologies in line with this policy. If you don't agree 
  or you change your mind later, you can withdraw your consent using the methods outlined 
  in this Policy, or you may choose to stop using our services.
</p>

<h4 style={{ color: "#0a4d68", marginTop: "30px" }}>Browser Settings</h4>
<p>
  Most web browsers automatically accept Cookies. You can modify your browser settings or 
  use certain software tools to control how Cookies are accepted by your browser. However, 
  blocking HHG INDUSTRIES PRIVATE LIMITED Essential Cookies may disable certain features of the 
  Website and impact your experience in using some of our services.
</p>

      </div>
    </div>
  );
};

export default CookiePolicy;
